module.exports = {"MOBILE_VIEW":false,"SPECIAL_COLOR":"#01B3C8","CASES_TO_OPEN_BARCODE_MODAL":["COMPLETE_PACKAGING","CHANNEL_BASED_COMPLETE_PACKAGING"],"PRINT_ORDER_DETAIL":true,"CASES_TO_OPEN_CARGO_SELECTION_MODAL":["SHIP_THE_PACKAGE_ADVANCED"],"BARCODE_VALIDATION":false,"IMAGE_WIDTH":600,"IMAGE_HEIGHT":600,"REDIRECT_AFTER_OUT_OF_STOCK":false}


//////////////////
// WEBPACK FOOTER
// ./src/plugins/tfs/platformConfigs/theme/clickAndCollectOrderDetail.json
// module id = 1372
// module chunks = 1